<template>
  <div class="eui-o-pdfviewer__zoom">
    <Button iconOnly size="large" color="primary" @click="zoomOut"><Icon name="less"/></Button>
    <span>{{ scaleBase100 }} %</span>
    <Button iconOnly size="large" color="primary" @click="zoomIn"><Icon name="more"/></Button>
    <!--<a @click.prevent.stop="fitWidth" class="icon" :disabled="isDisabled">ExpandIcon</a>
    <a @click.prevent.stop="fitAuto" class="icon" :disabled="isDisabled">ShrinkIcon</a>-->
  </div>
</template>
<script>
import Icon from '../../../atoms/Icon/Icon';
import Button from '../../../atoms/Button/Button';
import { PIXEL_RATIO } from '../utils/constants';

export default {
  name: 'PDFZoom',
  components: { Icon, Button },
  props: {
    scale: {
      type: Number,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
  },

  computed: {
    scaleBase100() {
      return Math.round(((this.scale + Number.EPSILON) / PIXEL_RATIO) * 100);
    },
    isDisabled() {
      return !this.scale;
    },
  },

  methods: {
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit('change', {scale});
    },

    fitWidth() {
      this.$emit('fit', 'width');
    },

    fitAuto() {
      this.$emit('fit', 'auto');
    },
  },
}
</script>
